require('./loanRepaymentPlan.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');
// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ commons
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ components
const LoanRepaymentPlanFilter = require('./loanRepaymentPlanFilter/loanRepaymentPlanFilter');
const LoanRepaymentPlanFiltersHeader = require('./loanRepaymentPlanFiltersHeader/loanRepaymentPlanFiltersHeader');
const LoanCollectiveTooltip = require('../loanCollectiveTooltip/loanCollectiveTooltip');
const LoanCollectiveTag = require('../loanCollectiveTag/loanCollectiveTag');
//@actions
const { clearLoanRepaymentPlanFilters, setLoanRepaymentPlanFilters, fetchRepaymentPlan, requestNextPage } = require('../../../actions/loanRepaymentPlan');
// @ constants
const { DATE_FORMAT_ES } = require('constants/index');
const {
    LOANS_MORTGAGES_PAYROLL_LOAN
} = require('../../../loansConstants/index');
//@analytics
const { catalogue, analyticsId } = require('../analytics/loansAndMortgagesAnalytics');
//@utilities
const { trackViewAndComercialSpace } = require('utilities/taggingViewHelper');
const {
    commonAnalyticsId,
    commonCatalogue,
    commonCatalogueFilters,
    commonFilterAnalyticsId,
} = require('utilities/taggingCommonCatalogue');const { recordLinkV2 } = require('utilities/tagging');

class LoanRepaymentPlan extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filtersOpen: false,
        };

        this.buildPlanTable = this.buildPlanTable.bind(this);
        this.handleFilterButtonClick = this.handleFilterButtonClick.bind(this);
        this.handleSetFilters = this.handleSetFilters.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.handleClearFilters = this.handleClearFilters.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
    }

    componentDidMount() {
        const { immLoan } = this.props;
        trackViewAndComercialSpace({
            immLoan,
            analyticView: catalogue[analyticsId.PAGE_VIEW_REPAYMENT_PLAN],
            productImpressionList: 'loanDepreciationPlan'
        });
    }

    buildEmptyState() {
        const primaryText = formatText('loanRepaymentPlan-emptyState');

        return (
            <EmptyState primaryText={primaryText} iconType="noitems-banking" />
        );
    }

    buildError() {
        const { loanId, fetchRepaymentPlan } = this.props;
        const handleRequest = () => {
            recordLinkV2(commonCatalogue[commonAnalyticsId.RETRY_BUTTON]());
            fetchRepaymentPlan(loanId);
        };
        const primaryText = formatText('loanRepaymentPlan-errorMessage');
        const retryText = formatText('loanRepaymentPlan-retry');
        const retryButton = (
            <OKButton onClick={handleRequest}>{retryText}</OKButton>
        );

        return (
            <EmptyState
                primaryText={primaryText}
                button={retryButton}
                iconType="nointernet-banking"
            />
        );
    }

    buildBadge() {
        const { immLoan, tooltipContentMortgage } = this.props;
        const type = immLoan.get('type');
        const isPayroll = type === LOANS_MORTGAGES_PAYROLL_LOAN;
        const tooltipContent = isPayroll ? <LoanCollectiveTooltip /> : tooltipContentMortgage;

        return (
            <LoanCollectiveTag
                extraClass="loan-repayment-plan__collective-tag"
                immLoan={immLoan}
                tooltipContent={tooltipContent}
            />
        );
    }

    buildHeader() {
        const { immLoanRepaymentPlan } = this.props;
        const immFilter = immLoanRepaymentPlan.get('filters');
        const title = formatText('loanRepaymentPlan-tableTitle');
        const badge = this.buildBadge();
        const headerClasses = classNames('loan-repayment-plan__header',
            {
                'loan-repayment-plan__header--has-filters': immFilter.get('isActive')
            }
        );
        let filterLabels;
        if (immFilter.get('isActive')) {
            filterLabels = (
                <LoanRepaymentPlanFiltersHeader
                    immFilter={immFilter}
                    onClearFilters={this.handleClearFilters}
                />
            );
        }
        let modal;
        if (this.state.filtersOpen) {
            modal = (
                <LoanRepaymentPlanFilter
                    immFilter={immFilter}
                    onSetFilters={this.handleSetFilters}
                    onCloseClick={this.handleToggleFilters}
                />
            );
        }

        return (
            <section className={headerClasses}>
                <OKBoxTitle value={title} />
                <div className="loan-repayment-plan__filters">
                    {badge}
                    <div className="loan-repayment-plan__header-filters pull-right">
                        <OKButton
                            id="btn_loan-repayment-plan-filter"
                            modifier="task"
                            onClick={this.handleFilterButtonClick}
                        >
                            <i className="icon-filtrar" />
                        </OKButton>
                    </div>
                </div>
                {modal}
                {filterLabels}
            </section>
        );
    }

    buildNextPageButton() {
        const { immLoanRepaymentPlan } = this.props;
        let buttonContent;

        if (immLoanRepaymentPlan.get('nextPage')) {
            if (!immLoanRepaymentPlan.get('isFetchingNextPage')) {
                buttonContent = (
                    <div className="loan-repayment-plan__more-movements">
                        <OKButton
                            modifier="link-complementary"
                            onClick={this.handleNextPage}
                        >
                            <FormattedText value="loanRepaymentPlan-moreMovements" />
                        </OKButton>
                    </div>
                );
            } else {
                buttonContent = <LoadingSection />;
            }
        }

        return buttonContent;
    }

    buildPlanTable() {
        const tableBody = this.buildTableBody();
        const nextPageButton = this.buildNextPageButton();

        return (
            <div>
                <OKTable
                    id="loan-repayment-plan-table"
                    className="loan-repayment-plan__table"
                >
                    <thead>
                        <OKTableRow asHeader={true}>
                            <OKTableCell asHeader={true}>
                                <FormattedText
                                    value="loanRepaymentPlan-date"
                                    format="firstUppercase"
                                />
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText
                                    value="loanRepaymentPlan-installments"
                                    format="firstUppercase"
                                />
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText
                                    value="loanRepaymentPlan-amortizedCapital"
                                    format="firstUppercase"
                                />
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText
                                    value="loanRepaymentPlan-interests"
                                    format="firstUppercase"
                                />
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText
                                    value="loanRepaymentPlan-pendingCapital"
                                    format="firstUppercase"
                                />
                            </OKTableCell>
                        </OKTableRow>
                    </thead>
                    <tbody>{tableBody}</tbody>
                </OKTable>
                {nextPageButton}
            </div>
        );
    }

    buildTableBody() {
        const { immLoanRepaymentPlan } = this.props;

        return immLoanRepaymentPlan.get('plan').map((immItem, index) => {
            const date = DateHelper.buildFormattedDate(immItem.get('date'), DATE_FORMAT_ES);
            const plainAmountInstallmentObject = getPlainAmountObject(immItem.get('installment'));
            const plainAmountAmortizedObject = getPlainAmountObject(immItem.get('amortizedCapital'));
            const plainAmountInterestObject = getPlainAmountObject(immItem.get('interests'));
            const plainAmountPendingObject = getPlainAmountObject(immItem.get('pendingCapital'));
            const language = getLanguage();

            return (
                <OKTableRow
                    key={index}
                    id={`loan-repayment-plan-table-row-${index}`}
                >
                    <OKTableCell className="loan-repayment-plan__table-row-date">
                        {date}
                    </OKTableCell>
                    <OKTableCell className="loan-repayment-plan__table-row-installment">
                        <OneLineSymbolAmount
                            amountObject={plainAmountInstallmentObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(
                                plainAmountInstallmentObject,
                                true
                            )}
                        />
                    </OKTableCell>
                    <OKTableCell className="loan-repayment-plan__table-row-amortizedCapital">
                        <OneLineSymbolAmount
                            amountObject={plainAmountAmortizedObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(
                                plainAmountAmortizedObject,
                                true
                            )}
                        />
                    </OKTableCell>
                    <OKTableCell className="loan-repayment-plan__table-row-interests">
                        <OneLineSymbolAmount
                            amountObject={plainAmountInterestObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(
                                plainAmountInterestObject,
                                true
                            )}
                        />
                    </OKTableCell>
                    <OKTableCell className="loan-repayment-plan__table-row-pendingCapital">
                        <OneLineSymbolAmount
                            amountObject={plainAmountPendingObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(
                                plainAmountPendingObject,
                                true
                            )}
                        />
                    </OKTableCell>
                </OKTableRow>
            );
        });
    }

    handleClearFilters() {
        const { clearLoanRepaymentPlanFilters, loanId } = this.props;
        clearLoanRepaymentPlanFilters(loanId);
    }

    handleFilterButtonClick() {
        this.setState({
            filtersOpen: true,
        });
        recordLinkV2(
            commonCatalogueFilters[
                commonFilterAnalyticsId.FILTER_BUTTON_CLICK
            ]()
        );
    }

    handleNextPage() {
        const { requestNextPage, loanId } = this.props;
        requestNextPage(loanId);
    }

    handleSetFilters(filters) {
        const { setLoanRepaymentPlanFilters, loanId } = this.props;
        setLoanRepaymentPlanFilters(filters, loanId);
    }

    handleToggleFilters() {
        this.setState({
            filtersOpen: !this.state.filtersOpen,
        });
    }

    render() {
        const { immLoanRepaymentPlan } = this.props;
        const header = this.buildHeader();
        let content;

        if (immLoanRepaymentPlan.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immLoanRepaymentPlan.get('error')) {
            content = this.buildError();
        } else if (immLoanRepaymentPlan.get('plan').isEmpty()) {
            content = this.buildEmptyState();
        } else {
            content = this.buildPlanTable();
        }

        return (
            <OKSectionBox>
                {header}
                {content}
            </OKSectionBox>
        );
    }
}

LoanRepaymentPlan.propTypes = {
    immLoan: PropTypes.object.isRequired,
    immLoanRepaymentPlan: PropTypes.object.isRequired,
    fetchRepaymentPlan: PropTypes.func.isRequired,
    setLoanRepaymentPlanFilters: PropTypes.func.isRequired,
    clearLoanRepaymentPlanFilters: PropTypes.func.isRequired,
    requestNextPage: PropTypes.func.isRequired,
    tooltipContentMortgage: PropTypes.object.isRequired,
    loanId: PropTypes.string.isRequired
};

module.exports = connect(null, {
    fetchRepaymentPlan,
    setLoanRepaymentPlanFilters,
    clearLoanRepaymentPlanFilters,
    requestNextPage
})(LoanRepaymentPlan);
